/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsSuspend } from "../funcs/agentsSuspend.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  SuspendAgentRequest,
  SuspendAgentSecurity,
} from "../models/operations/suspendagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsSuspendMutationVariables = {
  request: SuspendAgentRequest;
  security?: SuspendAgentSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsSuspendMutationData = ManagedAgent;

export type AgentsSuspendMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * suspend agents
 */
export function useAgentsSuspendMutation(
  options?: MutationHookOptions<
    AgentsSuspendMutationData,
    AgentsSuspendMutationError,
    AgentsSuspendMutationVariables
  >,
): UseMutationResult<
  AgentsSuspendMutationData,
  AgentsSuspendMutationError,
  AgentsSuspendMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsSuspendMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsSuspend(): MutationKey {
  return ["@gram/client", "agents", "suspend"];
}

export function buildAgentsSuspendMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsSuspendMutationVariables,
  ) => Promise<AgentsSuspendMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsSuspend(),
    mutationFn: function agentsSuspendMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsSuspendMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsSuspend(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
